import * as React from 'react';
import { SVGProps } from 'react';

const IconYoutubeSizeXs = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M10.794 3.767a1.253 1.253 0 0 0-.881-.881C9.13 2.672 6 2.672 6 2.672s-3.13 0-3.913.206c-.42.115-.766.46-.881.89C1 4.55 1 6.171 1 6.171s0 1.631.206 2.406c.115.428.453.766.881.881.791.214 3.913.214 3.913.214s3.13 0 3.913-.206c.428-.115.766-.453.881-.881C11 7.803 11 6.18 11 6.18s.008-1.631-.206-2.414Zm-5.79 3.905V4.673l2.602 1.5-2.603 1.499Z" />
  </svg>
);
export default IconYoutubeSizeXs;
